import React from 'react';
import { PiIntersectSquareDuotone } from 'react-icons/pi';
import { SUBMODULOS_INTEGRACAO } from '../../../components/sidebar/submodulos';
import { HubDoModulo } from '../HubDoModulo';

/** Hub da Integração no padrão do Contábil: cartões em vidro + submódulos no menu lateral. */
export default function ModulesDashBoardIntegrationPage() {
  return (
    <HubDoModulo
      nome="Integração"
      descricao="Conferência das notas importadas no Domínio: sequência, faturamento, importações diárias, lançamentos manuais, NFS-e, variância e duplicidades."
      cor="#CFEFFF"
      icone={<PiIntersectSquareDuotone size={32} color="#0A4E70" />}
      submodulos={SUBMODULOS_INTEGRACAO}
    />
  );
}
